<template>
<DxDataGrid
    :data-source="rows"
    :show-borders="false"
    :column-auto-width="true"
    :column-hiding-enabled="true"
    class="rounded-xl backdrop-blur w-full" style="background-color:#2b2b34;"
    @row-prepared="onRowPrepared"
  >
    <DxColumn data-field="name"       caption="Tank" />
    <DxColumn data-field="location"   caption="Location" />
    <DxColumn data-field="current"    caption="Current %" />
    <DxColumn data-field="currentL"   caption="Current (L)" alignment="left" />
    <DxColumn data-field="totalL"     caption="Total (L)" alignment="left" />
    <DxColumn data-field="dte"        caption="DTE (days)" />
    <DxColumn data-field="criticalBy" caption="Critical By" />
  </DxDataGrid>
</template>

<script setup>
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import useTankStats from './temp-data-and-supports/useTankStats.js';

const { rows } = useTankStats();

function onRowPrepared(e) {
  if (e.rowType === 'data' && e.data?.critical) {
    e.rowElement.classList.add('bg-red-900/40', 'text-red-200');
  }
}
</script>

<style scoped>
:deep(.dx-datagrid) {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
}
</style>
